BookingApp.controller('FlightsSearchController',function($scope,$http,$filter,$location,$timeout){



    $scope.request = {
        JourneyType:1,
        class:1,
        adult:1,
        child:0,
        infant:0
    };



    //Modufy Search section
    $scope.request.travellers = function(){
        return (parseInt($scope.request.adult) + parseInt($scope.request.child) + parseInt($scope.request.infant));
    }

    var today = moment([]);
    today.add(2,'days');
    var NextDate = today.clone();
    NextDate.add(5,'days');


    $scope.datePicker   = {
        options : {
            singleDatePicker : $scope.request.JourneyType == 1,
            autoApply:true,
        },
        min: new Date(),
        date : today.clone()
    }

    //console.log($scope.datePicker)


    $scope.$watch('request["JourneyType"]',function(n,v){
        $scope.datePicker.options.singleDatePicker = $scope.request.JourneyType == 1

        if($scope.datePicker.options.singleDatePicker){
            $scope.datePicker.date = today.clone();
        }else{
            $scope.datePicker.date = {
                startDate: today.clone(),
                endDate: NextDate.clone()
            }
        }
    });


    $scope.getOrigins = function (val){
        return $http.get('https://' + window.location.hostname + '/flights/suggestion/queries/' + val)
            .then(function(response){
                return response.data.map(function(item){
                    return item;
                });
            });;
    }

    $scope.getDestination = function(val){
        return $scope.getLocation(val);
    }

    $scope.getLocation = function (val){
        return $http.get('https://' + window.location.hostname + '/flights/suggestion/queries/' + val)
            .then(function(response){
                return response.data.map(function(item){
                    return item;
                });
            });
    }


    $scope.TravellerOpen = false;
    $scope.OpenTravellerPopUp = function(){
        if(!$scope.TravellerOpen){
            $scope.TravellerOpen = true;
            var ClkFn = function(ev){
                var con = $('.fsbd');
                var Position = con.offset();
                var Width = con.outerWidth();
                var Heiht = con.outerHeight();
                var cond = ev.clientX > Position.left && ev.clientX < (Position.left + Width) && ev.clientY > Position.top && ev.clientY < (Position.top + Heiht)
                if(!$(ev.target).hasClass('travellerInput') && !cond){
                    $scope.TravellerOpen = false;
                    $scope.$apply();
                    window.removeEventListener('click',ClkFn,true)
                }
            }
            window.addEventListener('click',ClkFn,true)
        }
    }
    $scope.closepopup = function(){
        $scope.TravellerOpen = false;
    }

    $scope.searchFlight = function(){

        if(!angular.isDefined($scope.request.origin) || !angular.isDefined($scope.request.origin.city_code)) {
            $scope.ShowErrorMsg('Please Select valid origin from suggestion.');
            return;
        }

        if(!angular.isDefined($scope.request.destination) || !angular.isDefined($scope.request.destination.city_code)){
            $scope.ShowErrorMsg('Please Select valid destination from suggestion.');
            return;
        }


        var request = {};//$scope.request;
        if($scope.request.JourneyType == 2 )
        {
            request.startDate = $scope.datePicker.date.startDate.format('YYYYMMDD');
            request.endDate =   $scope.datePicker.date.endDate.format('YYYYMMDD');

            //console.log(request);
            if($scope.datePicker.date.endDate == null) return;
            $('#modifysearch').modal('hide');

            fbq('track', 'Search', {
                search_string: 'flight-from-'+ $scope.request.origin.city_code + '-to-' + $scope.request.destination.city_code + '-on-' + request.startDate + '-' + request.endDate
            });

            $location.path('flights/search/from-'+ $scope.request.origin.city_code + '-to-' + $scope.request.destination.city_code + '-on-' + request.startDate + '-' + request.endDate + '-' + $scope.request.JourneyType + '-' + $scope.request.adult + '-' + $scope.request.child + '-' + $scope.request.infant + '-' + $scope.request.class);
        }
        else
        {
            request.JourneyDate = $scope.datePicker.date.format('YYYYMMDD');
            $('#modifysearch').modal('hide')

            fbq('track', 'Search', {
                search_string: 'flight-from-'+ $scope.request.origin.city_code + '-to-' + $scope.request.destination.city_code + '-on-' + request.JourneyDate
            });

            $location.path('flights/search/from-'+ $scope.request.origin.city_code + '-to-' + $scope.request.destination.city_code + '-on-' + request.JourneyDate + '-' + $scope.request.JourneyType + '-' + $scope.request.adult + '-' + $scope.request.child + '-' + $scope.request.infant + '-' + $scope.request.class);
        }
    }

    $scope.ShowErrorMsg = function (msg){
        $scope.ErrorMsg = msg;
        $scope.hasError = true;
        $timeout(function(){
            $scope.ErrorMsg = "";
            $scope.hasError = false;
        },3000)
    }
});

